"use strict";
/*
 * Copyright 2019 NEM
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Catapult REST Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.7.21
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
* Type of transaction: * 0x414C (16716 decimal) - AccountLinkTransaction. * 0x4141 (16705 decimal) - AggregateCompleteTransaction. * 0x4241 (16961 decimal) - AggregateBondedTransaction. * 0x414D (16717 decimal) - MosaicDefinitionTransaction. * 0x424D (16973 decimal) - MosaicSupplyChangeTransaction. * 0x414E (16718 decimal) - NamespaceRegistrationTransaction. * 0x424E (16974 decimal) - AddressAliasTransaction. * 0x434E (17230 decimal) - MosaicAliasTransaction. * 0x4144 (16708 decimal) - AccountMetadataTransaction. * 0x4244 (16964 decimal) - MosaicMetadataTransaction. * 0x4344 (17220 decimal) - NamespaceMetadataTransaction. * 0x4155 (16725 decimal) - MultisigAccountModificationTransaction. * 0x4148 (16712 decimal) - HashLockTransaction. * 0x4152 (16722 decimal) - SecretLockTransaction. * 0x4252 (16978 decimal) - SecretProofTransaction. * 0x4150 (16720 decimal) - AccountAddressRestrictionTransaction. * 0x4250 (16976 decimal) - AccountMosaicRestrictionTransaction. * 0x4350 (17232 decimal) - AccountOperationRestrictionTransaction. * 0x4151 (16721 decimal) - MosaicGlobalRestrictionTransaction. * 0x4251 (16977 decimal) - MosaicAddressRestrictionTransaction. * 0x4154 (16724 decimal) - TransferTransaction.
*/
var TransactionTypeEnum;
(function (TransactionTypeEnum) {
    TransactionTypeEnum[TransactionTypeEnum["NUMBER_16716"] = 16716] = "NUMBER_16716";
    TransactionTypeEnum[TransactionTypeEnum["NUMBER_16705"] = 16705] = "NUMBER_16705";
    TransactionTypeEnum[TransactionTypeEnum["NUMBER_16961"] = 16961] = "NUMBER_16961";
    TransactionTypeEnum[TransactionTypeEnum["NUMBER_16717"] = 16717] = "NUMBER_16717";
    TransactionTypeEnum[TransactionTypeEnum["NUMBER_16973"] = 16973] = "NUMBER_16973";
    TransactionTypeEnum[TransactionTypeEnum["NUMBER_16718"] = 16718] = "NUMBER_16718";
    TransactionTypeEnum[TransactionTypeEnum["NUMBER_16974"] = 16974] = "NUMBER_16974";
    TransactionTypeEnum[TransactionTypeEnum["NUMBER_17230"] = 17230] = "NUMBER_17230";
    TransactionTypeEnum[TransactionTypeEnum["NUMBER_16708"] = 16708] = "NUMBER_16708";
    TransactionTypeEnum[TransactionTypeEnum["NUMBER_16964"] = 16964] = "NUMBER_16964";
    TransactionTypeEnum[TransactionTypeEnum["NUMBER_17220"] = 17220] = "NUMBER_17220";
    TransactionTypeEnum[TransactionTypeEnum["NUMBER_16725"] = 16725] = "NUMBER_16725";
    TransactionTypeEnum[TransactionTypeEnum["NUMBER_16712"] = 16712] = "NUMBER_16712";
    TransactionTypeEnum[TransactionTypeEnum["NUMBER_16722"] = 16722] = "NUMBER_16722";
    TransactionTypeEnum[TransactionTypeEnum["NUMBER_16978"] = 16978] = "NUMBER_16978";
    TransactionTypeEnum[TransactionTypeEnum["NUMBER_16720"] = 16720] = "NUMBER_16720";
    TransactionTypeEnum[TransactionTypeEnum["NUMBER_16976"] = 16976] = "NUMBER_16976";
    TransactionTypeEnum[TransactionTypeEnum["NUMBER_17232"] = 17232] = "NUMBER_17232";
    TransactionTypeEnum[TransactionTypeEnum["NUMBER_16721"] = 16721] = "NUMBER_16721";
    TransactionTypeEnum[TransactionTypeEnum["NUMBER_16977"] = 16977] = "NUMBER_16977";
    TransactionTypeEnum[TransactionTypeEnum["NUMBER_16724"] = 16724] = "NUMBER_16724";
})(TransactionTypeEnum = exports.TransactionTypeEnum || (exports.TransactionTypeEnum = {}));
//# sourceMappingURL=transactionTypeEnum.js.map